<div class="barcode-scan">
	<tec-scan [match]="scanning && cameraReady">
		<div class="barcode-scan__viewport">
			@for (v of [videoRemountVersion]; track v) {
				<div class="barcode-scan__video-root">
					<app-video
						[debugMode]="false"
						[animationFrame]="0"
						[constraints]="constraints"
						[forceFlipHorizontal]="true"
						[forceFreshGetUserMedia]="true"
						[zoomFactor]="1"
						[zoomOffsetX]="0"
						[zoomOffsetY]="0"
						(cameraError)="onCameraError($event)"
						(cameraPermissionRevoked)="onCameraPermissionRevoked()"
						(cameraStarted)="onCameraStarted($event)"
					/>
				</div>
			}
			<img
				class="barcode-scan__overlay"
				src="assets/images/scan-barcode-overlay.svg"
				alt=""
				aria-hidden="true"
			/>
			<canvas #canvasEl class="barcode-scan__canvas"></canvas>
			@if (!cameraReady) {
				<div class="barcode-scan__loading">
					<tec-spinner size="sm" />
				</div>
			}
		</div>
	</tec-scan>
	@if (instructionI18nKey) {
		<span class="barcode-scan__instruction" [innerHTML]="instructionI18nKey | translate"></span>
	}
	@if (errorMsg) {
		<p class="barcode-scan__error">{{ errorMsg }}</p>
	}
</div>
